import script from "./ModalTarefaInfos.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalTarefaInfos.vue?vue&type=script&setup=true&lang=js"

import "./ModalTarefaInfos.vue?vue&type=style&index=0&id=3ad87424&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ad87424"]])

export default __exports__